export const general = [
  'users:find',
  'users:get',
  'users:patch',
  'users:create',
  'verifications:get',
  'verifications:patch'
];

export const home = [
  'metrics:find',
  'payout-reports:get'
];

export const charges = [
  'charges:find',
  'charges:get',
  'charges:create',
  'reports:create'
];

export const balance = [
  'payout-reports:find',
  'payout-reports:get'
];

export const customers = [
  'customers:find',
  'customers:get',
  'customers:create',
  'customers:patch'
];

export const invoices = [
  'invoices:find',
  'invoices:get',
  'invoices:create',
  'invoices:patch'
];

export const settings = [
  'currencies:find',
  'currencies:get',
  'organization-currencies:patch',
  'organization-currencies:find',
  'organization-owners:find',
  'organization-owners:get',
  'organization-owners:create',
  'organization-owners:patch',
  'organization-owners:remove',
  'organization-users:find',
  'organization-users:get',
  'organization-users:remove',
  'organizations:find',
  'organizations:get',
  'organizations:create',
  'organizations:patch',
  'payout-information:find',
  'payout-information:get',
  'payout-information:create',
  'payout-information:patch',
  'invites:find',
  'invites:get',
  'invites:create',
  'invites:patch'
];

export const webhooks = [
  'webhooks:find',
  'webhooks:get',
  'webhooks:create',
  'webhooks:patch',
  'webhooks:remove'
];

export const merchant = [
  ...home,
  ...charges,
  ...balance,
  ...customers,
  ...invoices,
  ...settings,
  ...webhooks
];

export const reseller = [
  'organization-currencies:create',
  'organization-currencies:remove',
  'payout-information:processing-fee',
  'payout-reports:patch',
  'resellers:get',
  'resellers:patch',
  'roles:find',
  'organizations:approve',
  'roles:get',
  'roles:create',
  'roles:patch'
];

export const admin = [
  'charge-events:create',
  'organization-currencies:patch:markup',
  'organizations:find:all',
  'resellers:find',
  'resellers:create',
  'users:find:all',
  'addresses:find',
  'monthly-payout-reports:create'
];
